import { createFileRoute } from '@tanstack/react-router';
import { ManejoView } from '@/modules/agronomia/components/ManejoView';

// Telas 06-10 · Manejo por categoria (Adubação/Herbicidas/Fungicidas/Inseticidas/Nutrição).
export const Route = createFileRoute('/_authed/agronomia_/manejo_/$id_/$cat')({
  component: Page,
});

function Page() {
  const { id, cat } = Route.useParams();
  return <ManejoView talhaoId={Number(id)} categoria={cat} />;
}
